"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var validateInputContent = function validateInputContent(field, value) {
  var inputWithText = ['firstName', 'lastName'];
  var inputWithNumbers = ['routingNumber', 'accountNumber', 'confirmAccountNumber'];
  var regexValidation;
  if (inputWithNumbers.includes(field)) {
    var regex = /^[0-9]*$/g;
    regexValidation = value.match(regex) === null && 'Error: input content validation failed';
  }
  if (inputWithText.includes(field)) {
    var _regex = /^[a-zA-Z]*$/g;
    regexValidation = value.match(_regex) === null && 'Error: input content validation failed';
  }
  return regexValidation;
};
var _default = validateInputContent;
exports["default"] = _default;
